export default __webpack_public_path__ + "static/media/graphic.acba83fa.png";